// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"UserSidebarView_dropdownMenu__t_JLB","link":"UserSidebarView_link__iSbRg","active":"UserSidebarView_active__5cC8Y","off":"UserSidebarView_off__mkSkA"};